import Swal from "sweetalert2";
import organigramaImage from "../Images/organi_investi.png"; // Importa la imagen

// Función para mostrar el modal del organigrama
export const mostrarModalOrganigrama = () => {
  // Detecta si es un dispositivo móvil basado en el ancho de pantalla
  const isMobile = window.innerWidth <= 768;
  
  Swal.fire({
    title: "Organigrama Empresarial",
    html: `
      <div style="text-align: center;">
        <img src="${organigramaImage}" alt="Organigrama" style="max-width: 100%; height: auto; border-radius: 10px;"/>
      </div>
    `,
    showCloseButton: true,
    showConfirmButton: false,
    background: "#003e9c",
    color: "var(--white)",
    width: isMobile ? "100%" : "50%", // Usar 90% en móviles, 50% en escritorio
    backdrop: "rgba(0, 0, 0, 0.5)",
  });
};

// Otras funciones existentes (sin cambios)
export const mostrarModalInfo = (titulo, mensaje) => {
  Swal.fire({
    title: titulo,
    html: `<div style="font-size: 15px;">${mensaje}</div>`,
    showCloseButton: true,
    showConfirmButton: false,
    background: "#003e9c",
    color: "var(--white)",
    width: "450px",
    backdrop: "rgba(0, 0, 0, 0.5)",
    scrollbarPadding: false,
  });
};

export const mostrarModalError = (mensaje) => {
  Swal.fire({
    title: "Error",
    text: mensaje,
    icon: "error",
    confirmButtonText: "Cerrar",
  });
};

export const mostrarModalExito = (mensaje) => {
  Swal.fire({
    title: "¡Éxito!",
    text: mensaje,
    icon: "success",
    confirmButtonText: "Aceptar",
  });
};

export const mostrarModalConfirmacion = (mensaje, callback) => {
  Swal.fire({
    title: "¿Estás seguro?",
    text: mensaje,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí",
    cancelButtonText: "No",
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback();
    }
  });
};